import { useState } from 'react';

import { CancelApplication } from './cancel-application';
import { WhyDoYouCancelLoan } from './why-do-you-cancel-loan';

export function LoanCancelModal() {
  const [isSetReasonState, setIsSetReasonState] = useState<boolean>(false);
  const handleCancelLoan = () => {
    setIsSetReasonState(true);
  };

  return (
    <>
      {isSetReasonState ? (
        <WhyDoYouCancelLoan />
      ) : (
        <CancelApplication handleCancelLoan={handleCancelLoan} />
      )}
    </>
  );
}
